import { render, staticRenderFns } from "./CardLockerAwaitingUsers.vue?vue&type=template&id=56d06714&"
import script from "./CardLockerAwaitingUsers.vue?vue&type=script&lang=js&"
export * from "./CardLockerAwaitingUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports